/* eslint-disable no-restricted-syntax */
import React from "react";
import { Wrapper, ContentTypeRender } from "nystem-components";
import app from "nystem";

const SftpDropArea = ({ model, path, children, ...props }) => {
  const { dropId, className } = model || props;

  const preventDefault = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    const items = await Promise.all(
      [...e.dataTransfer.items].filter((item) => item.kind === "file").map((item) => item.getAsFileSystemHandle()),
    );

    app.event("fileDrop", { files: items, dropId });
  };

  return (
    <Wrapper onDrop={handleDrop} onDragOver={preventDefault} className={className}>
      {children || <ContentTypeRender path={path} items={model.item} />}
    </Wrapper>
  );
};

export default SftpDropArea;
